<ul class="inm-nav">
  @for (nav of navigation(); track nav.routing_path + $index) {
    @let translated = nav.translate | translate;

    <li class="inm-nav__item">
      <a
        class="inm-nav__link"
        routerLinkActive="is-active"
        [routerLink]="'/' + nav.routing_path"
        [routerLinkActiveOptions]="{ exact: nav.routing_path === '' }"
        (click)="closeNavigation.emit(true)"
      >
        @if (nav.icon) {
          <i class="inm-nav__icon {{ nav.icon }}" aria-hidden="true"></i>
        }
        <!-- ngx-translate devuelve la propia clave cuando el backend no la tiene:
             en ese caso se cae al texto de respaldo del item. -->
        <span>{{ translated === nav.translate ? (nav.label ?? nav.translate) : translated }}</span>
      </a>
    </li>
  }

  <li class="inm-nav__item inm-nav__item--action">
    <app-notifications />
  </li>

  <li class="inm-nav__item inm-nav__item--action">
    <app-login-button />
  </li>

  <li class="inm-nav__item inm-nav__item--action">
    <label class="visually-hidden" for="languagePicker">Idioma</label>
    <select id="languagePicker" class="inm-nav__language" [formControl]="languageControl()">
      @for (language of languages(); track language.id) {
        <option [value]="language.abbreviation">{{ language.name }}</option>
      }
    </select>
  </li>
</ul>
